import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '吃瓜热评', href: '#comments' },
  { label: '吃瓜排行榜', href: '#ranking' },
  { label: '热门话题', href: '#topics' },
  { label: '精彩视频', href: '#media' },
  { label: '焦点专题', href: '#carousel' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-[0_1px_3px_rgba(0,0,0,0.06)]'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-[64px] px-4 md:px-6 max-w-[1400px] mx-auto">
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
          className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
        >
          <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-chat-smile-2-fill text-lg text-white"></i>
          </span>
          <span className="font-heading text-lg font-bold text-foreground-900">
            51吃瓜app
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                item.label === '首页'
                  ? 'text-primary-600'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200/70'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-200 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-4 py-3">
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className={`px-4 py-2.5 text-sm font-medium rounded-lg transition-colors cursor-pointer ${
                  item.label === '首页'
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200/70'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}